module.exports = __webpack_public_path__ + "img/step1.3a956a81.jpg";